import {
    BannerEditDisplayConditions,
    CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS,
    ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS,
    ON_CHANGE_TEXT_TYPE_VIEW_DISPLAY_CONDITIONS,
    ON_ERROR_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS,
    ON_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS,
    ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS
} from '../../actions/banners-edit/banner-edit-display-conditions';
import {
    bannerHasDisplayConditions,
    EditBannersState
} from '../../typings/bannersEditState';

export function bannersEditDisplayConditionsReducer(
    state: EditBannersState,
    action: BannerEditDisplayConditions
): EditBannersState {
    const editedBanner = state.banners[action.id];
    if (!bannerHasDisplayConditions(editedBanner)) {
        return state;
    }

    switch (action.type) {
        case ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS:
            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.id]: {
                        ...editedBanner,
                        displayConditions: {
                            ...editedBanner.displayConditions,
                            isOpen: !editedBanner.displayConditions.isOpen
                        }
                    }
                }
            };
        case ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS:
            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.id]: {
                        ...editedBanner,
                        displayConditions: {
                            ...editedBanner.displayConditions,
                            isLoading: true
                        }
                    }
                }
            };
        case ON_CHANGE_TEXT_TYPE_VIEW_DISPLAY_CONDITIONS:
            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.id]: {
                        ...editedBanner,
                        displayConditions: {
                            ...editedBanner.displayConditions,
                            keywordsTextTypeView: action.keywordsTextTypeView
                        }
                    }
                }
            };
        case ON_ERROR_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS:
            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.id]: {
                        ...editedBanner,
                        displayConditions: {
                            ...editedBanner.displayConditions,
                            isLoading: false,
                            isOpen: false
                        }
                    }
                }
            };
        case ON_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS:
            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.id]: {
                        ...editedBanner,
                        displayConditions: {
                            ...editedBanner.displayConditions,
                            keywords: action.keywords,
                            retargeting: action.retargeting,
                            isLoading: false
                        }
                    }
                }
            };
        case CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS:
            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.id]: {
                        ...editedBanner,
                        displayConditions: {
                            ...editedBanner.displayConditions,
                            copyTooltipStatus: action.newStatus
                        }
                    }
                }
            };
        default:
            return state;
    }
}
